import React from "react";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import CommonModal from "./CommonModal";
import ErrorBoundary from "../error-boundary";
import ModalFallback from "../error-boundary/fallback/ModalFallback";
import { FaRegQuestionCircle, FaRegEnvelope } from "react-icons/fa";
import { FiShield, FiPhone } from "react-icons/fi";
import { Link } from "react-router-dom";
import { accountingSoftwareModalData } from "../../locales/en";
import {
  CALL_NO_AU,
  CALL_NO_NZ,
  COUNTRY_CODE_AU,
  COUNTRY_CODE_NZ,
  INFO_EMAIL
} from "../../utils/constants/appConstants";
import AccountingSoftwareList from "../../pages/invoiceconnect/accounting-software-list/AccountingSoftwareList";
import "./accountingSoftConnected.scss";
import { useSelector } from "react-redux";

const AccountingSoftConnectedModal = ({ isOpen, toggle }) => {
  const { profile: loggedUserData } = useSelector(
    (state) => state.userManagement
  );
  const userData = loggedUserData;

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName={`accounnting-soft-connected-modal modal-dialog-centered modal-dialog-scrollable-hide`}
      bodyClassName={Modalstyle.commentModalWrap}
      backDrop
      hideFooter
    >
      <ErrorBoundary fallback={<ModalFallback fixHeight="300px" />}>
        <div className="connecting-soft-modal-header">
          <span className="help-tooltip-wrapper">
            <FaRegQuestionCircle className="help-icon" />
            <div className="help-tooltip-box">
              <h5>{accountingSoftwareModalData?.modalHover?.title}</h5>
              <ul>
                {accountingSoftwareModalData?.modalHover?.whyChooseList?.map(
                  (item, index) => (
                    <li key={index}>{item?.itemList}</li>
                  )
                )}
              </ul>
              <div className="security-text">
                <p>
                  <FiShield />
                  {accountingSoftwareModalData?.modalHover?.securityText}
                </p>
              </div>
              <div className="need-help">
                <strong>
                  {accountingSoftwareModalData?.modalHover?.helpText}
                </strong>
                <p>
                  <span>
                    <FaRegEnvelope />
                  </span>
                  <span>{INFO_EMAIL}</span>
                </p>
                <p>
                  <span>
                    <FiPhone />
                  </span>
                  <span>
                    {COUNTRY_CODE_AU} : {CALL_NO_AU} <br /> {COUNTRY_CODE_NZ} :{" "}
                    {CALL_NO_NZ}
                  </span>
                </p>
              </div>
            </div>
          </span>
        </div>
        <div id="connectingSoftModal">
          <div className="connecting-soft-modal-conetnt">
            <p className="welcome-text">
              {accountingSoftwareModalData?.welcomeText}{" "}
              {` ${userData?.firstName}`}.
            </p>
            <h2>{accountingSoftwareModalData?.title}</h2>
            <p>{accountingSoftwareModalData?.content}</p>
          </div>
          <AccountingSoftwareList />
        </div>
        <div className="connecting-soft-modal-footer">
          <Link to="#" onClick={toggle}>
            {accountingSoftwareModalData?.modalHover?.dontUse}
          </Link>
        </div>
      </ErrorBoundary>
    </CommonModal>
  );
};
AccountingSoftConnectedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default AccountingSoftConnectedModal;
